// src/store/slices/saveFormSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import apiUrl from '../../services/api';

// Async thunk to call API
export const saveRegistrationInfo = createAsyncThunk(
  'form/saveRegistrationInfo',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(apiUrl.saveRegistrationInfo, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const saveFormSlice = createSlice({
  name: 'form',
  initialState: {
    loading: false,
    success: false,
    error: null,
  },
  reducers: {
    resetFormState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveRegistrationInfo.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(saveRegistrationInfo.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(saveRegistrationInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { resetFormState } = saveFormSlice.actions;
export default saveFormSlice.reducer;
